import React, { useEffect, useState } from "react";
import firstimg from "../../../img/step1.png";
import { Link } from "react-router-dom";

const Step1 = () => {
  return (
    <>
      <section className="step_1  wow  fadeInUp animated">
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="step1_img">
              <div className="voice_img"></div>
              <img src={firstimg} className="img-fluid" alt="first-img" />
            </div>
          </div>

          <div className="col-md-6">
            <div className="step1_text">
              <h1>Welcome to our 3-minute online hearing screener</h1>
              <p>
                With this echoears online hearing screener, it only takes a few
                minutes to find out how well you're hearing.
              </p>
              <p>You need headphones or earphones for this test.</p>

              <Link to="/hearingtest/age-range">
                {" "}
                <button className="btn">Let’s Start!</button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step1;
